import React, { FunctionComponent, useState, useEffect } from "react";
import {
  MedigapPlan,
  getPhasedOutPlanWaiverStatus,
  MedigapPlanType,
} from "../utils/plans";
import PhasedOutDisclaimer from "../Plans/PhasedOutDisclaimer";
import states from "../../EnrollmentFormPage/states";
import exclamationIcon from "../../../assets/exclamation.svg";
import { FormattedMessage } from "react-intl-phraseapp";
import { useTranslate } from "../../../helpers";

const PlanNotes: FunctionComponent<{ plan: MedigapPlan }> = ({ plan }) => {
  const [stateName, setStateName] = useState("");
  const t = useTranslate();

  useEffect(() => {
    const { state: stateAbbrev } = plan;

    if (stateAbbrev) {
      const state = states.find(state => state.abbreviation === stateAbbrev);

      if (state) {
        setStateName(state.name);
      }
    }
  }, []);

  return (
    <div className="MedigapPlanDetails__notes">
      {stateName && (
        <FormattedMessage
          tagName="p"
          id="medigap.plan_notes.only_available_in_state"
          values={{ stateName }}
        />
      )}

      {plan && getPhasedOutPlanWaiverStatus(plan) && (
        <PhasedOutDisclaimer plan={plan} className="MedigapPlanCard__info" />
      )}

      <p>
        <img
          src={exclamationIcon}
          height="16"
          className="ds-u-margin-right--1"
          alt=""
        />
        <span>{t("medigap.plan_notes.information_shown_is_estimate")}</span>
      </p>

      {plan.plan_type === MedigapPlanType.MA_SUPP_1A && (
        <p>{t("medigap.plan_notes.ma_supp_1a")}</p>
      )}

      {plan.plan_type === MedigapPlanType.MN_EXT_BASIC_NEW && (
        <p>{t("medigap.plan_details.plan_note_mn_ext_basic_new")}</p>
      )}

      {plan.plan_type === MedigapPlanType.MN_HIGH_F_NEW && (
        <p>{t("medigap.plan_details.plan_note_mn_high_f_new")}</p>
      )}

      {plan.plan_type === MedigapPlanType.MN_HIGH_F && (
        <p>{t("medigap.plan_details.plan_note_mn_high_f")}</p>
      )}

      {plan.plan_type === MedigapPlanType.MN_SUPP_50 && (
        <p>{t("medigap.plan_details.plan_note_mn_supp_50")}</p>
      )}

      {plan.plan_type === MedigapPlanType.MN_SUPP_75 && (
        <p>{t("medigap.plan_details.plan_note_mn_supp_75")}</p>
      )}

      {plan.plan_type === MedigapPlanType.MN_N && (
        <p>{t("medigap.plan_details.plan_note_mn_n")}</p>
      )}
    </div>
  );
};

export default PlanNotes;
